var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedGoec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6084 36.6788C32.1755 34.7315 34.7703 32.6977 36.3773 29.905C38.0537 26.9915 38.9941 23.598 38.9941 19.9755C38.9941 9.12779 30.2637 0.333984 19.4941 0.333984C8.72459 0.333984 -0.00585938 9.12779 -0.00585938 19.9755C-0.00585938 25.3435 2.05907 30.2085 5.52399 33.7539L17.754 43.4115C18.4307 44.4991 19.9987 44.5141 20.6957 43.4395L29.6084 36.6788Z",
    fill: "#D25B5B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4937,
    cy: 19.5161,
    r: 16.9634,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8221 21.5909L29.2384 16.5883C30.4962 20.7113 28.9909 25.329 25.2312 27.8578C20.6261 30.9638 14.3714 29.7475 11.2647 25.1366C8.15794 20.5326 9.38139 14.2795 13.9865 11.1735C17.3338 8.91961 21.5471 8.94022 24.7845 10.8918L29.4858 7.72392C24.3652 3.43604 16.8321 2.84508 11.0172 6.76189C3.97894 11.5171 2.11629 21.0755 6.86574 28.1121C11.6152 35.1555 21.1691 37.0108 28.2074 32.2694C34.414 28.0846 36.5997 20.1753 33.7748 13.5305C33.3967 12.6371 32.9294 11.7644 32.3657 10.9261C31.9258 10.2733 31.4516 9.66862 30.9292 9.11202L18.8872 17.2343C17.6843 18.0451 17.3682 19.6806 18.1792 20.8831C18.9903 22.0787 20.6193 22.4017 21.8221 21.5909Z",
    fill: "#D25B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1864 17.9945L20.0497 23.7262C20.0978 23.8018 20.2009 23.8156 20.2696 23.7675L23.3767 21.6713C23.4523 21.6232 23.4661 21.5201 23.418 21.4514L19.5547 15.7197C19.5066 15.6441 19.4035 15.6303 19.3348 15.6784L16.2276 17.7746C16.1589 17.8227 16.1382 17.9189 16.1864 17.9945Z",
    fill: "#D25B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 20.9827C14.7016 21.1752 14.9695 21.2302 15.1618 21.0996L17.4901 19.5253C17.6824 19.3948 17.7374 19.1266 17.6069 18.9341C17.4764 18.7417 17.2085 18.6867 17.0162 18.8173L14.6879 20.3915C14.4956 20.5222 14.4406 20.7834 14.5711 20.9827Z",
    fill: "#D25B5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.774 21.7366C16.9045 21.9291 17.1722 21.9841 17.3644 21.8535L19.6914 20.2793C19.8836 20.1486 19.9385 19.8806 19.8081 19.6881C19.6777 19.4956 19.41 19.4406 19.2178 19.5712L16.8908 21.1454C16.6917 21.2761 16.6436 21.5373 16.774 21.7366Z",
    fill: "#D25B5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6689 24.1019C16.7998 24.2944 17.0684 24.3494 17.2614 24.2188L19.597 22.6445C19.7899 22.5139 19.8451 22.2458 19.7141 22.0533C19.5832 21.8608 19.3145 21.8058 19.1216 21.9364L16.786 23.5107C16.5862 23.6413 16.5379 23.9025 16.6689 24.1019Z",
    fill: "#D25B5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0567 18.3809L19.411 19.0884L19.7415 19.6106L18.2197 20.2288L20.6367 19.9472L20.2924 19.4251L21.6214 19.2602L21.0567 18.3809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedGoec);
export default __webpack_public_path__ + "static/media/redGoec.85a07ae517660f7351589f766a35004b.svg";
export { ForwardRef as ReactComponent };